<!-- FILTERS -->
<form class="sticky-form-container" cdkScrollable [ngClass]="{'expanded': showMobileFilters}" #searchForm="ngForm" *ngIf="!routeService.isWindow && !isEventView"
      (ngSubmit)="isFormValid && search()" autocomplete="off">
  <!-- GENERAL SEARCH -->
  <div class="flex space-between" *ngIf="showMobileFilters">
    <span class="heading-2 break-word">{{ 'general.api_event_search_filters' | translate }}</span>
    <div class="align-right">
      <button mat-button class="icon-button" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-filters flex-column-mobile flex-wrap">
    <div class="flex" *ngIf="utilService.isMobile">
      <app-text-input class="mobile-max-width" [withSuffix]="!showMobileFilters"
                      [label]="'general.api_search_event_or_location'" [(value)]="searchTerm" [min]="3">
        <button mat-button class="icon-button input-button suffix-button" (click)="isFormValid && search()">
          <mat-icon class="svg-icon" [svgIcon]="'search'"></mat-icon>
        </button>
      </app-text-input>
      <div class="mobile no-min-width" *ngIf="!showMobileFilters">
        <button type="button" mat-button class="icon-button input-button mobile" (click)="toggleFilters()">
          <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
        </button>
      </div>
    </div>
    <app-text-input class="desktop" [label]="'general.api_search_event_or_location'"
                    [(value)]="searchTerm" [min]="3"></app-text-input>
    <!-- DETAILED SEARCH -->
    <div *ngIf="isDetailedSearch && utilService.isMobile && showMobileFilters" class="flex flex-column-mobile">
      <ng-container [ngTemplateOutlet]="extraFields"></ng-container>
    </div>
    <ng-container *ngIf="isDetailedSearch && !utilService.isMobile" [ngTemplateOutlet]="extraFields"></ng-container>
    <div class="flex" *ngIf="!utilService.isMobile">
      <button mat-button type="button" class="desktop" (click)="clearFilters()">
        {{ 'general.api_general_clear_all' | translate }}
      </button>
      <button mat-flat-button color="primary" class="desktop" [disabled]="!isFormValid" type="submit">
        {{ 'general.api_search' | translate }}
      </button>
    </div>
    <footer *ngIf="showMobileFilters" class="search-footer mobile">
      <mat-dialog-actions>
        <button mat-button type="button" (click)="clearFilters()">
          {{ 'general.api_general_clear_all' | translate }}
        </button>
        <button mat-flat-button color="primary" [disabled]="!isFormValid" type="submit">
          {{ 'general.api_search' | translate }}
        </button>
      </mat-dialog-actions>
    </footer>
  </div>
</form>
<!-- EVENTS LIST -->
<div *ngIf="!showMobileFilters || !utilService.isMobile" [ngClass]="{'window': routeService.isWindow, 'with-footer': cartService.currentBooking?.number}">
  <ng-container *ngIf="!isLoading && !isEventView && isSearchResults && results.items.length">
    <div class="view-header flex space-between">
      <div class="flex flex-column-mobile">
        <mat-form-field class="no-hint dynamic-width">
          <mat-label>{{'general.api_sort_by' | translate}}:</mat-label>
          <mat-select [(ngModel)]="sortBy" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-option *ngFor="let sortByOption of sortByOptions" [value]="sortByOption.id">
              {{sortByOption.title | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="no-hint dynamic-width">
          <mat-label>{{'general.api_search_display' | translate}}:</mat-label>
          <mat-select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-option *ngFor="let pageSizeValue of pageSizeOptions" [value]="pageSizeValue">
              {{pageSizeValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex">
        <button mat-button class="icon-button desktop" [ngClass]="{'active': viewType === 'table-no-image'}"
                (click)="switchView('table-no-image')">
          <mat-icon class="svg-icon" [svgIcon]="'list_view'"></mat-icon>
        </button>
        <button mat-button class="icon-button" [ngClass]="{'active': (viewType === 'table' || (utilService.isMobile && viewType === 'table-no-image'))}"
                (click)="switchView('table')">
          <mat-icon class="svg-icon" [svgIcon]="'thumbnail_view'"></mat-icon>
        </button>
        <button mat-button class="icon-button" [ngClass]="{'active': viewType === 'card'}"
                (click)="switchView('card')">
          <mat-icon class="svg-icon" [svgIcon]="'card_view'"></mat-icon>
        </button>
      </div>
    </div>
    <div class="body-2 text-muted" *ngIf="!!viewService.conf.environment && !cartService.isEmpty && authService.user.supportsYbo">
      <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
      {{ (cartService.isSelfService ? 'general.api_cart_only_bo_events_allowed' : 'general.api_cart_only_legacy_events_allowed') | translate }}
    </div>
    <div class="event-cards" *ngIf="viewType === 'card'">
      <app-card-item *ngFor="let event of results.items" [event]="event"
                     (openEventDetails)="openEventDetails($event)"
                     (openPurchaseView)="openPurchaseView($event)"
                     (openEventBookings)="openEventBookings($event)"></app-card-item>
    </div>
    <div class="event-cards mobile" *ngIf="utilService.isMobile && viewType !== 'card'">
      <app-mobile-card-item *ngFor="let event of results.items" [event]="event"
                            (openEventDetails)="openEventDetails($event)"
                            (openPurchaseView)="openPurchaseView($event)"
                            (openEventBookings)="openEventBookings($event)"></app-mobile-card-item>
    </div>
    <div class="desktop">
      <table class="event-table" *ngIf="viewType !== 'card'">
        <tbody>
          <app-table-item *ngFor="let event of results.items" [event]="event"
                          [ngClass]="{'fade-out': eventService.isFadedOut(event, cartService.cartDraftEvent)}"
                          [hasImage]="viewType === 'table'"
                          (openEventDetails)="openEventDetails($event)"
                          (openPurchaseView)="openPurchaseView($event)"
                          (openEventBookings)="openEventBookings($event)"></app-table-item>
        </tbody>
      </table>
    </div>
    <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
  </ng-container>
  <!-- EVENT PURCHASE -->
  <ng-container *ngIf="!isLoading && isEventView">
    <app-event-purchase (searchEvent)="searchTerm = $event; search()"></app-event-purchase>
  </ng-container>
  <app-loader [loading]="isLoading"></app-loader>
</div>
<ng-container *ngIf="!routeService.isWindow && !isEventView">
  <app-booking-footer *ngIf="cartService.currentBooking?.number && (!utilService.isMobile || !showMobileFilters)" [isStandalone]="true"></app-booking-footer>
</ng-container>
<ng-template #extraFields>
  <!-- DATE START -->
  <app-datepicker [(dateStart)]="filters.dateStart" [(dateEnd)]="filters.dateEnd"
                  [datePickerConfig]="{range: true, autoBindDates: true, allowDateClear: true, noHint: true}"></app-datepicker>
  <!-- VENUE -->
  <app-scroll-load [label]="'general.api_venue'" [minInput]="3"
                    [customQuery]="selfServiceVenueService.setActiveVenuesQuery"
                    [searchService]="selfServiceVenueService" [scrollLoad]="selfServiceVenueScrollLoad"
                    [(selectedObjectId)]="filters.eventVenueId"></app-scroll-load>
  <!-- LEGAL PERSON -->
  <app-scroll-load *ngIf="authService.user.isSuperCentre"
                    [label]="'general.api_customers_table_legal_persons'"
                    [customQuery]="legalPersonService.setPageableQueryExcludeUnclaimed"
                    [searchService]="legalPersonService" [scrollLoad]="legalPersonScrollLoad"
                    (selectedObjectIdChange)="selectLegalPerson()"></app-scroll-load>
  <!-- STATUS -->
  <mat-form-field appearance="outline">
    <mat-label>{{'general.api_event_status' | translate}}</mat-label>
    <mat-select [disableOptionCentering]="true" [(ngModel)]="filters.status" [ngModelOptions]="{standalone: true}">
      <mat-select-trigger>{{getStatusLabelById(filters.status) | translate}}</mat-select-trigger>
      <mat-option [value]="null">-</mat-option>
      <mat-option *ngFor="let eventStatus of eventStatuses" [value]="eventStatus.id">
        {{eventStatus.name | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>